import { render, staticRenderFns } from "./AvgDaysOpenByMonth.vue?vue&type=template&id=31381ec6"
import script from "./AvgDaysOpenByMonth.vue?vue&type=script&lang=js"
export * from "./AvgDaysOpenByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports